<template>
  <div class="qr-code-wrp">
    <canvas
      ref="qrCode"
      :class="{
        'mr-3': hasMarginRight,
      }"
      class="w-full"
    />
  </div>
</template>

<script>
import Qrious from 'qrious'

export default {
  props: {
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      qr: null,
    }
  },
  watch: {
    value(newValue) {
      this.qr.set({
        value: newValue,
      })
    },
  },
  mounted() {
    this.qr = new Qrious({
      level: 'H',
      element: this.$refs.qrCode,
      value: this.value,
      size: 512,
    })
  },
}
</script>

<style lang="scss" scoped>
.qr-code-wrp {
  @apply p-2 rounded-xl;
  background-color: #fff;
}
</style>
